import { render, staticRenderFns } from "./ToggleList.vue?vue&type=template&id=f4a1a9c4&"
import script from "./ToggleList.vue?vue&type=script&lang=js&"
export * from "./ToggleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports